<template>
  <b-card
    no-body
    class="border-primary"
  >
    <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
      <h5 class="mb-1">
        Проверяющий:
      </h5>
    </b-card-header>

    <b-card-body>

      <h4 class="mb-0">{{userData.full_name}}</h4>

      <small class="text-muted">@{{ userData.username }}</small>
    </b-card-body>
    <b-card-body>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        :to="{ name: 'users-user-view', params: { id: userData.id } }"
      >
        Перейти к профилю
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BBadge, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  props: {
    userData: {
      type: [Object, null],
      default: "",
    },
  },
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
  },
}
</script>

<style>

</style>
